import taskRoutes from '../components/tasks/routes';
import processesRoutes from '../components/processes/routes';
import userRoutes from '../components/user/routes';
import tenantRoutes from '../components/tenants/routes';
import surveyRoutes from '../components/surveys/routes';
import operatoriesRoutes from '../components/operatories/routes';
import callSheetRoutes from '../components/callsheet/routes';

import {MILLISECONDS_IN_MINUTE} from './constants';
import {Process} from './processes';
import {ProcessFilter} from '../components/processes/types';
import {convertDateTimeToUTC} from '../components/callsheet/helpers';

import learnImagePath from '../assets/images/learn.png';
import doImagePath from '../assets/images/do.png';
import improveImagePath from '../assets/images/improve.png';
import planImagePath from '../assets/images/plan.png';

import {NavigationCardConfig} from '../components/dashboard/types';

export enum CardType {
  MY_TASKS = 'MY_TASKS',
  MY_GROUPS_TASKS = 'MY_GROUPS_TASKS',
  ALL_TASKS = 'ALL_TASKS',
  RUNNING_PROCESSES = 'RUNNING_PROCESSES',
  BUSY_OPERATORIES = 'BUSY_OPERATORIES',
  TC_OVERTIMES = 'TC_OVERTIMES',
  CE_OVERTIMES = 'CE_OVERTIMES',
  CALL_SHEET_THIS_MONTH = 'CALL_SHEET_THIS_MONTH',
  TENANT_USERS = 'TENANT_USERS',
  TENANTS = 'TENANTS',
  BAD_FEEDBACK_THIS_MONTH = 'BAD_FEEDBACK_THIS_MONTH',
  COMPLETED_PTNT_SRV_THIS_MONTH = 'COMPLETED_PTNT_SRV_THIS_MONTH'
}

export const REFRESH_TIME_IN_MINUTES = {
  [CardType.RUNNING_PROCESSES]: 5,
  [CardType.ALL_TASKS]: 1,
  [CardType.MY_GROUPS_TASKS]: 1,
  [CardType.MY_TASKS]: 1,
  [CardType.TENANT_USERS]: 30,
  [CardType.TENANTS]: 30,
  [CardType.BUSY_OPERATORIES]: 5,
  [CardType.TC_OVERTIMES]: 10,
  [CardType.CE_OVERTIMES]: 10,
  [CardType.COMPLETED_PTNT_SRV_THIS_MONTH]: 30,
  [CardType.BAD_FEEDBACK_THIS_MONTH]: 30,
  [CardType.CALL_SHEET_THIS_MONTH]: 20
};

export const getRefreshTime = (code: CardType): number => {
  return REFRESH_TIME_IN_MINUTES[code] * MILLISECONDS_IN_MINUTE || 0;
};

const currentDate = new Date();

export const cardCodeToRoute = {
  [CardType.RUNNING_PROCESSES]: {
    route: processesRoutes.list(),
    state: null
  },
  [CardType.ALL_TASKS]: {
    route: taskRoutes.allTasks(),
    state: null
  },
  [CardType.MY_GROUPS_TASKS]: {
    route: taskRoutes.groupTasks(),
    state: null
  },
  [CardType.MY_TASKS]: {
    route: taskRoutes.userTasks(),
    state: null
  },
  [CardType.TENANT_USERS]: {
    route: userRoutes.tenantUsers(),
    state: null
  },
  [CardType.TENANTS]: {
    route: tenantRoutes.tenants(),
    state: null
  },
  [CardType.BUSY_OPERATORIES]: {
    route: operatoriesRoutes.overview(),
    state: null
  },
  [CardType.TC_OVERTIMES]: {
    route: processesRoutes
        .runningProcessesByType(Process.TREATMENT_CARE),
    state: {filter: ProcessFilter.BEHIND}
  },
  [CardType.CE_OVERTIMES]: {
    route: processesRoutes
        .runningProcessesByType(Process.CLINICAL_EVALUATION),
    state: {filter: ProcessFilter.BEHIND}
  },
  [CardType.COMPLETED_PTNT_SRV_THIS_MONTH]: {
    route: surveyRoutes.list(),
    state: null
  },
  [CardType.BAD_FEEDBACK_THIS_MONTH]: null,
  [CardType.CALL_SHEET_THIS_MONTH]: {
    route: `${callSheetRoutes.list()}?direction=asc&sort=APPOINTMENT_DATE`,
    state: {
      initialFilters: {APPOINTMENT_AFTER: currentDate},
      initialFiltersBody: [{
        type: 'APPOINTMENT_AFTER',
        value: convertDateTimeToUTC(currentDate)
      }]
    }
  }
};

export enum NavigationCardType {
  LEARN = 'learn',
  DO = 'do',
  IMPROVE = 'improve',
  PLAN = 'plan'
}

export const NAVIGATION_CARDS_CONFIG: NavigationCardConfig[] = [
  {
    type: NavigationCardType.LEARN,
    icon: learnImagePath,
    isExternalLink: true,
    path: process.env.REACT_APP_SERVICE_LMS_LINK || ''
  },
  {
    type: NavigationCardType.DO,
    icon: doImagePath,
    isExternalLink: false,
    path: processesRoutes.list()
  },
  {
    type: NavigationCardType.IMPROVE,
    icon: improveImagePath,
    isExternalLink: false,
    path: '/improve'
  },
  {
    type: NavigationCardType.PLAN,
    icon: planImagePath,
    isExternalLink: false,
    path: processesRoutes.start()
  }
];
